var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B88DB89A-FDF0-4A4D-AD93-D72537D68F62") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.1324226,18 L0.867577407,18 C0.50231338,18 0.319626572,17.8126508 0.136994558,17.6249828 C-0.0456648527,17.4375211 -0.0456648527,17.0625039 0.136994558,16.6874867 L9.26941715,0.375129687 C9.45207656,0.187574218 9.63473597,0 10,0 C10.3652914,0 10.5479782,0.187461719 10.7305828,0.375129687 L19.8630054,16.6874867 C20.0456649,16.8749297 20.0456649,17.2500594 19.8630054,17.6249828 C19.6804008,17.8126508 19.497714,18 19.1324226,18 Z M1.65,16.6658023 L18.35,16.6658023 L9.99998509,1.76727273 L1.65,16.6658023 Z M10.9132423,11.2478585 L10.9132423,7.12295064 C10.9132423,6.56037798 10.5479782,6.18545455 10,6.18545455 C9.45204916,6.18545455 9.08675774,6.56037798 9.08675774,7.12295064 L9.08675774,11.2478585 C9.08675774,11.8104311 9.45204916,12.1853545 10,12.1853545 C10.5479782,12.1853545 10.9132423,11.6228756 10.9132423,11.2478585 Z M10.7305828,14.6250328 C10.9132423,14.4375711 11.0959017,14.0626664 11.0959017,13.8749984 C11.0959017,13.6874242 10.9132149,13.3125195 10.7305828,13.1249453 C10.5479234,12.9375023 10.1826594,12.7499281 10,12.7499281 C9.63473597,12.7499281 9.45204916,12.9375023 9.26941715,13.1249453 C9.08675774,13.312407 8.90412573,13.6874242 8.90412573,13.8749984 C8.90412573,14.0626664 9.08681436,14.4375711 9.26941715,14.6250328 C9.45207656,14.8124945 9.81736799,15.0001625 10,15.0001625 C10.3652914,15.0001625 10.5479782,14.8124945 10.7305828,14.6250328 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Data-Upload",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ERRORS-FILE-FORMAT",
    transform: "translate(-374.000000, -422.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drag-drop_error",
    transform: "translate(233.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/error---0",
    transform: "translate(140.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colors/notification/error-red",
    transform: "translate(1.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#323E48",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#E7251A",
    id: "Rectangle-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon_error.d8f68119.svg";
export { ForwardRef as ReactComponent };